export const STATE_SUFFIX = '8baseApp';
